// Module
var code = " <div class=\"form-control-static\"> <a ng-href=\"{{model[options.key]}}\" target=\"_blank\">{{to.Text}}</a> </div> ";
// Exports
export default code;